
import React from 'react';
import { Rocket } from 'lucide-react';
import KitTemplate from '@/components/hq/KitTemplate';

const LaunchKit = () => {
  const sections = {
    downloads: {
      title: "🔹 Downloads",
      description: "Essential documents and resources for studio launches",
      files: [
        { name: "JUV Welcome Deck", type: "pdf" as const, size: "2.4 MB", placeholder: true },
        { name: "Grand Opening Checklist", type: "docx" as const, size: "1.2 MB", placeholder: true },
        { name: "Location Readiness Sheet", type: "pdf" as const, size: "1.8 MB", placeholder: true },
        { name: "Local Market Checklist", type: "docx" as const, size: "950 KB", placeholder: true }
      ]
    },
    sops: {
      title: "🔸 SOPs",
      description: "Standard operating procedures for launch preparation",
      files: [
        { name: "How to Prepare Your Studio for Launch", type: "pdf" as const, placeholder: true },
        { name: "Onboarding Your First Staff Members", type: "pdf" as const, placeholder: true },
        { name: "Creating Your Launch Timeline", type: "pdf" as const, placeholder: true },
        { name: "Submitting Your Grand Opening Request", type: "pdf" as const, placeholder: true }
      ]
    },
    training: {
      title: "🎓 Training",
      description: "Training materials for launch preparation",
      files: [
        { name: "How to Use the Launch Tracker", type: "mp4" as const, placeholder: true },
        { name: "Studio Tour Setup Guide", type: "pdf" as const, placeholder: true },
        { name: "Working with HQ on Launch Assets", type: "mp4" as const, placeholder: true }
      ]
    }
  };

  return (
    <KitTemplate
      kitId="launch"
      kitTitle="Launch Kit"
      kitDescription="Everything you need to open a new JUV Studio with confidence"
      icon={<Rocket className="h-6 w-6 text-amber-400" />}
      sections={sections}
    />
  );
};

export default LaunchKit;
